/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'fabric.editor.headingLink.ascSortingLabel': 'ascending',
  'fabric.editor.headingLink.copied': 'Copied!',
  'fabric.editor.headingLink.copyAnchorLink': 'Copy link to heading',
  'fabric.editor.headingLink.copyAriaLabel': 'Copy',
  'fabric.editor.headingLink.descSortingLabel': 'descending',
  'fabric.editor.headingLink.failedToCopy': 'Copy failed',
  'fabric.editor.headingLink.noneSortingLabel': 'none',
  'fabric.editor.inlineComment.marker.end': 'inline comment end',
  'fabric.editor.inlineComment.marker.start': 'inline comment start',
};
